function getApiEndpoint() {
	return "https://demo.inqutec.in/api/v1/videoSeeker/";
}

function getVideoSearchUrl(searchQuery) {
	return `${getApiEndpoint()}search?query=${searchQuery}`
}

export {getApiEndpoint, getVideoSearchUrl}